import { render, staticRenderFns } from "./CompOrderState.vue?vue&type=template&id=ce3d60ba"
import script from "./CompOrderState.vue?vue&type=script&setup=true&lang=js"
export * from "./CompOrderState.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports